import { Component, OnInit, Input } from '@angular/core';
import { FollowTrainService } from '../follow-train.service';
import { map, takeWhile, tap, take, filter } from 'rxjs/operators';

@Component({
  selector: 'qm-follow-train-overlay',
  templateUrl: './follow-train-overlay.component.html',
  styleUrls: ['./follow-train-overlay.component.scss']
})
export class FollowTrainOverlayComponent implements OnInit {

  public currentTrain$ = this.followTrainService.selectedTrain$;
  /**
   * Is overlay visible
   */
  public isVisible$ = this.currentTrain$.pipe(map(feature => feature !== null));
  /**
   * Train's current speeds
   */
  public currentVelocity$ = this.followTrainService.followedTrainOrLocData$.pipe(
    filter(feature => feature !== null),
    map(feature => feature.velocity)
  );

  constructor(public followTrainService: FollowTrainService) { }


  ngOnInit() {
  }

  /**
   * Train ID in the top box clickeds
   */
  async handleTrainNumberClick() {
    this.followTrainService.highlightCurrentlyFollowedTrain();
  }

}
